export default __webpack_public_path__ + "static/media/portadavideoconfiguracion7.49322ac2.png";